export default "__VITE_ASSET__C_$WFmFU__"